import { apiClient, handleResponse } from './axios';

async function getExamModality() {
  try {
    const response = await apiClient
      .get('/exammodality');
    const examModality = await handleResponse(response);
    return examModality;
  } catch (error) {
    return error.response;
  }
}

const examModalityServices = {
  getExamModality,
};

export default examModalityServices;
